/* unplugin-vue-components disabled */import { render } from "./StudioVideo.vue?vue&type=template&id=2ab506b9&scoped=true"
import script from "./StudioVideo.vue?vue&type=script&lang=js"
export * from "./StudioVideo.vue?vue&type=script&lang=js"

import "./StudioVideo.vue?vue&type=style&index=0&id=2ab506b9&lang=scss&scoped=true"

import exportComponent from "C:\\Users\\Public\\object\\xvideos-frontend\\mysex\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2ab506b9"]])

export default __exports__